module.exports = __webpack_public_path__ + "img/1507010936.d10571d4.jpg";